/**
 * `pathname` + `current` with `patch` applied. A null or empty value drops its
 * key, so a view sitting at its defaults keeps a bare link; every key the
 * patch does not name is kept as it was.
 */
export function patchQueryHref(
  pathname: string,
  current: URLSearchParams,
  patch: Record<string, string | null>,
): string {
  const next = new URLSearchParams(current);
  Object.entries(patch).forEach(([key, value]) => {
    if (value === null || value === "") next.delete(key);
    else next.set(key, value);
  });
  const qs = next.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}
